const SubmitButton = ({ isDisabled, text, customClassName, customStyle }) => {
  const buttonStyle = {
    backgroundColor: isDisabled ? 'var(--grey300)' : 'var(--color-primary)',
    color: isDisabled ? 'var(--color-white)' : 'var(--color-white)',
    ...customStyle,
  };

  const className = customClassName ? customClassName : '';

  return (
    <button
      type="submit"
      style={buttonStyle}
      className={`btn ${className}`}
      disabled={isDisabled}
    >
      {text}
    </button>
  );
};

export default SubmitButton;
